'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.ExceptionParser = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _unserialize = require('./unserialize');

var _unserialize2 = _interopRequireDefault(_unserialize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.unserialize = _unserialize2.default;

var ExceptionParser = exports.ExceptionParser = function () {
	function ExceptionParser() {
		_classCallCheck(this, ExceptionParser);
	}

	_createClass(ExceptionParser, [{
		key: 'isException',
		value: function isException(logMessage) {
			return this.isRegularException(logMessage) || this.isBackgroundJobException(logMessage);
		}
	}, {
		key: 'isRegularException',
		value: function isRegularException(logMessage) {
			return logMessage.substr(0, 12) === 'Exception: {';
		}
	}, {
		key: 'isBackgroundJobException',
		value: function isBackgroundJobException(logMessage) {
			return logMessage.substr(0, 34) === 'Error while running background job' && logMessage.indexOf('{"Exception":') !== -1;
		}
	}, {
		key: 'parse',
		value: function parse(logMessage) {
			var data = void 0;
			if (this.isRegularException(logMessage)) {
				data = JSON.parse(logMessage.substr(10));
			} else {
				data = JSON.parse(logMessage.substr(logMessage.indexOf('{"Exception":')));
				var messageHead = logMessage.substr(0, logMessage.indexOf('{"Exception":'));
				var jobDataString = messageHead.split('(', 2)[1];
				var jobDataParts = jobDataString.split(',', 2).map(function (part) {
					return part.trim();
				});
				data.jobClass = jobDataParts[0].split(':', 2)[1].trim();
				data.jobArguments = jobDataParts[1].substr(10).trim();
				window.s = jobDataParts[1].substr(10).trim();
				if (data.jobClass === 'OC\\Command\\CommandJob') {
					try {
						var _parseCommandJob = this.parseCommandJob(data.jobArguments);

						var _parseCommandJob2 = _slicedToArray(_parseCommandJob, 2);

						data.jobClass = _parseCommandJob2[0];
						data.jobArguments = _parseCommandJob2[1];
					} catch (e) {}
				}
			}
			var traceLines = data.Trace.split('\n');
			data.Trace = traceLines.map(this.parseTraceLine);
			return data;
		}
	}, {
		key: 'parseCommandJob',
		value: function parseCommandJob(data) {
			var parsed = (0, _unserialize2.default)(data);
			return [parsed['class'], parsed.properties];
		}
	}, {
		key: 'parseTraceLine',
		value: function parseTraceLine(line) {
			var parts = line.split(' ');
			var number = parts.shift();
			var traceData = parts.join(' ');
			parts = traceData.split(':');

			if (parts.length > 1) {
				var file = void 0,
				    lineNumber = void 0;
				var fileAndLine = parts.shift();
				var call = parts.join(' ');
				if (fileAndLine[0] === '[') {
					lineNumber = false;
					file = fileAndLine;
				} else {
					var filePaths = fileAndLine.split('(', 2);
					file = filePaths[0];
					lineNumber = filePaths[1].substr(0, filePaths[1].length - 1);
				}
				return {
					call: call,
					number: number,
					file: file,
					lineNumber: lineNumber
				};
			} else {
				return {
					call: traceData,
					number: number,
					file: false,
					lineNumber: false
				};
			}
		}
	}]);

	return ExceptionParser;
}();


//////////////////
// WEBPACK FOOTER
// ./js/ExceptionParser.js
// module id = 607
// module chunks = 0